import { render, staticRenderFns } from "./StatisticsLicenseSale.vue?vue&type=template&id=73f5200a&scoped=true"
import script from "./StatisticsLicenseSale.vue?vue&type=script&lang=ts"
export * from "./StatisticsLicenseSale.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsLicenseSale.vue?vue&type=style&index=0&id=73f5200a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f5200a",
  null
  
)

export default component.exports